var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.item)?_c('Form',{attrs:{"mode":"edit","selected-item":_vm.item},on:{"click-submit-form":_vm.onSubmitForm}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }